import {DataFrameSpec} from 'data-frames/DataFrameTypes';
import {
  ColumnHeaderTransformOptions,
  RetypeColumnType,
} from 'data-frames/header-menu/DataFrameHeaderMenuOptions';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';

/**
 * Get `DataFrameRetypeColumnOptions`, used to inject logic for retyping columns into a data frame table.
 *
 * @package
 */
export default function getRetypeColumnOptions(
  dataFrameSpec: DataFrameSpec,
  currentConfig: PipelineStepConfig<PipelineStepType.RETYPE_COLUMNS, 0> | null,
  updateConfig: (newConfig: PipelineStepConfig<PipelineStepType.RETYPE_COLUMNS, 0>) => Promise<void>,
  deleteStep: () => Promise<void>
): ColumnHeaderTransformOptions[PipelineStepType.RETYPE_COLUMNS] {
  const retypeColumn = (columnSystemName: string, newType?: RetypeColumnType): Promise<void> => {
    const retypesToKeep = (currentConfig?.retypeColumns ?? []).filter(
      (retype) => retype.column !== columnSystemName
    );
    const updatedRetypes = newType
      ? [...retypesToKeep, {column: columnSystemName, type: newType}]
      : retypesToKeep;

    if (updatedRetypes.length > 0) {
      return updateConfig({retypeColumns: updatedRetypes});
    } else {
      return deleteStep();
    }
  };

  return {retypeColumn};
}
